export default {"src":"/_next/static/media/CRO.242d3b38.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};